exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".question-step .step-tag {\n  display: inline-block;\n  width: 36px;\n  text-align: center;\n  font-size: 16px;\n  background: #00b1ff;\n  border-radius: 4px;\n  margin: 15px 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"importLoaders":1}!./src/entry_question_editor/question/exercise/step/index.less
// module id = 1114
// module chunks = 60 61 62